// Shared fragment for quiz mutation payload types
// Works with: NewQuizAttemptPayload, ProcessQuizQuestionResponsePayload
export const NEW_QUIZ_ATTEMPT_PAYLOAD_FIELDS = `
  fragment NewQuizAttemptPayloadFields on NewQuizAttemptPayload {
    quizAttemptId
    status
    topicApiName
    topic {
      preamble
      scoreThreshold
      scoreThresholdRequired
      minutesToComplete
    }
    questions {
      questionOrder
      quizQuestionId
      questionText
      response {
        userResponse
        agentGrade
        agentFeedback
        pointScore
        maxPoints
      }
    }
    results {
      overallScore
      scoreThresholdMet
      finishedAt
      retakeAllowed
    }
  }
`;

export const PROCESS_QUIZ_QUESTION_RESPONSE_PAYLOAD_FIELDS = `
  fragment ProcessQuizQuestionResponsePayloadFields on ProcessQuizQuestionResponsePayload {
    quizAttemptId
    status
    topicApiName
    topic {
      preamble
      scoreThreshold
      scoreThresholdRequired
      minutesToComplete
    }
    questions {
      questionOrder
      quizQuestionId
      questionText
      response {
        userResponse
        agentGrade
        agentFeedback
        pointScore
        maxPoints
      }
    }
    results {
      overallScore
      scoreThresholdMet
      finishedAt
      retakeAllowed
    }
  }
`;
